import { render, staticRenderFns } from "./api-attachments-modal.vue?vue&type=template&id=1f25d7e4&"
import script from "./api-attachments-modal.vue?vue&type=script&lang=js&"
export * from "./api-attachments-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports